module.exports = __webpack_public_path__ + "media/images/iconEdit__inactive--dark-a409bda3c01bd637272b44183b2c2ce2.png";